import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ clipRadius?: number }>()(
  ({}, { clipRadius }) => ({
    infiniteScroll: {
      overflow: 'hidden !important',
    },
    clip: {
      clipPath: clipRadius ? `inset(0 round ${clipRadius}px)` : undefined,
    },
    overflowVisible: {
      overflow: 'visible !important',
    },
  }),
);
